import app from 'firebase/app';
import 'firebase/firestore'
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/messaging';

// import { GeoFirestore } from 'geofirestore';

const firebaseConfigProd = {
    apiKey: "AIzaSyCkf7F8bJfypJOtG04WdpogQMC0LtCkJiI",
    authDomain: "getthebox-starting.firebaseapp.com",
    databaseURL: "https://getthebox-starting.firebaseio.com",
    projectId: "getthebox-starting",
    storageBucket: "getthebox-starting.appspot.com",
    messagingSenderId: "783103712416",
    appId: "1:783103712416:web:1b73cf1a955f64bec37dc5"
};

const firebaseConfigDev = {
    apiKey: "AIzaSyDGVPehUbHua5YPEAopwUBBdijiiTH3k1c",
    authDomain: "getthebox-dev.firebaseapp.com",
    databaseURL: "https://getthebox-dev.firebaseio.com",
    projectId: "getthebox-dev",
    storageBucket: "getthebox-dev.appspot.com",
    messagingSenderId: "522915757029",
    appId: "1:522915757029:web:2071c18c6ac440339f0d0c",
    measurementId: "G-FLRBVWS2R1"
};

class Firebase {
    constructor() {
        app.initializeApp(process.env.REACT_APP_DEV === 'true' ? firebaseConfigDev : firebaseConfigProd);

        // const geofirestore = new GeoFirestore(app.firestore());

        this.auth = app.auth();
        this.db = app.firestore();
        this.firestore = app.firestore;
        this.functions = app.functions();
        this.messaging = app.messaging.isSupported() ? app.messaging() : false;

        // this.geoSenders = geofirestore.collection('geosenders');
        // this.geoRecipients = geofirestore.collection('georecipients');
    }

    doSignInWithEmailAndPassword = (email, password) =>
        this.auth.signInWithEmailAndPassword(email, password);

    doSignOut = () => this.auth.signOut();

    callFunction = (functionName, functionParams) => new Promise(resolve => {
        const calledFunction = this.functions.httpsCallable(functionName);

        calledFunction(functionParams).then(result => {
            resolve(result.data);
        }).catch(error => {
            console.warn(`Error when calling ${functionName} with params ${JSON.stringify(functionParams)}`, error.code, error.message, error.details);
            resolve({
                error: 'Callable error, see console for details',
            })
        });
    })
}

export default Firebase;
